import { ColumbiaErrorsProvider } from '@ben/columbia/contexts';
import BenefitDetailScreen from './benefit-detail';

const BenefitDetailScreenEntry = () => (
  <ColumbiaErrorsProvider>
    <BenefitDetailScreen />
  </ColumbiaErrorsProvider>
);

export default BenefitDetailScreenEntry;
